import { Form, Select } from "antd";
import { FC, ComponentType } from "react";
import { NATIONALITIES } from "src/Seed/Countries/Countries";

type NationalitySelectWebProps = {
  name: string;
  rules: any[];
  icon: ComponentType<{ className?: string }>;
  label: string;
  hasError: boolean;
  onOpen?: () => void;
};

const NationalitySelectWeb: FC<NationalitySelectWebProps> = ({ name, icon: Icon, label, hasError, rules, onOpen }) => {
  return (
    <div className="flex w-full flex-1 items-center px-3">
      <div className={hasError ? "text-font-danger" : "text-icon-minimal"}>
        <Icon className="h-4! w-4!" />
      </div>
      <div className="m-0! w-full! md:flex-1!">
        <Form.Item name={name} rules={rules} className="m-0! w-full! border-b! border-border-default font-semibold! md:flex-1! md:border-none! min-w-20!">
          <Select
            placeholder={label}
            showSearch={{ optionFilterProp: "label" }}
            options={NATIONALITIES}
            className={`w-full max-w-full! font-semibold ${hasError ? "text-font-danger" : ""}`}
            variant="borderless"
            onClick={onOpen}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default NationalitySelectWeb;
